import { Box, styled } from '@mui/material';

const StyledEmptyResultBlockContainer = styled(Box)(() => ({
  textAlign: 'center'
}));

export default StyledEmptyResultBlockContainer;
